module.exports = __webpack_public_path__ + "img/nasa-logo.bfef093b.png";